"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePageId = void 0;
/**
 * Genera un nuevo ID único.
 * @returns {string} - Nuevo ID generado.
 */
const newID = () => {
    return Math.random().toString(36).substr(2, 9);
};
/**
 * Genera un ID de página compuesto por seis ID únicos separados por guiones.
 * Asigna el ID de página a window.pageId.
 * @returns {string} - ID de página generado.
 */
const generatePageId = () => {
    const uuidArray = Array.from({ length: 6 }, newID);
    const res = uuidArray.join("-");
    try {
        window.pageId = res;
    }
    catch (err) {
        console.log(err);
    }
    return res;
};
exports.generatePageId = generatePageId;
exports.default = exports.generatePageId;
//# sourceMappingURL=index.js.map